export default {
  app_name: 'Rebase',
  website: 'https://www.rebase.co.il',
  finance_email: 'finance@rebase.co.il',
  phone_number: '03-5535344',
}
